import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiGetShippingMethod, apiGetUserAddress, apiUpdateUserAddress } from "Root/api/apiCheckout";
import { setGlobalLoading } from "Root/profile/redux/actionCreators/makeActionCreator";
import { setEditPaymentMethod, setEditShippingAddress, setEditShippingMethod, setOpenValidateAddressDrawer, setValidateAddressDrawerState, setCheckoutSegment, } from "./checkoutComponentSlice";
import toastService from "Root/profile/toastService";
import { fetchPricing } from "./checkoutPricingSlice";
const initState = {
    address: {
        country: "",
        firstName: "",
        lastName: "",
        street: "",
        state: "",
        city: "",
        apartment: "",
        zip: "",
        shipping_method: "standard",
    },
    cautiousAddress: {
        country: "",
        firstName: "",
        lastName: "",
        street: "",
        state: "",
        city: "",
        apartment: "",
        zip: "",
        shipping_method: "",
    },
    shippingMethodsData: {
        standard_shipping_price: 0,
        expedited_shipping_price: 0,
        shipping_methods: [],
    },
    isLoadingShippingMethods: false,
};
export const mapAddressObject = (data, backwards = false) => ({
    country: data.country,
    address: data.street,
    address2: data.apartment,
    city: data.city,
    zip: data.zip,
    state: data.state,
    firstName: data.firstName,
    lastName: data.lastName,
    name: `${data.firstName} ${data.lastName}`,
    email: data.email,
    phone: data.phone,
});
const mapBackendAddress = (data) => ({
    country: data.country,
    street: data.address,
    apartment: data.address2,
    city: data.city,
    zip: data.zip,
    state: data.state,
    firstName: data.firstName,
    lastName: data.lastName,
    name: `${data.firstName} ${data.lastName}`,
    shipping_method: "standard",
});
export const submitShippingAddress = createAsyncThunk("users/submitShippingAddress", async ({ body, verify }, { dispatch, getState }) => {
    try {
        const state = getState();
        const { isInfluencer } = state.checkoutComponent;
        dispatch(setGlobalLoading(true));
        const data = await apiUpdateUserAddress({ ...mapAddressObject(body), verify, type: "both" });
        dispatch(setGlobalLoading(false));
        dispatch(fetchShippingData());
        dispatch(setCheckoutSegment(""));
        dispatch(fetchPricing(body.shipping_method));
        if (isInfluencer) {
            dispatch(setEditPaymentMethod(false));
            dispatch(setEditShippingAddress(false));
            dispatch(setEditShippingMethod(false));
        }
        else {
            dispatch(setEditPaymentMethod(false));
            dispatch(setEditShippingAddress(false));
            dispatch(setEditShippingMethod(true));
        }
        dispatch(setShippingInfo(body));
        return data;
    }
    catch (error) {
        if (error.message) {
            const response = JSON.parse(error.message);
            if ("address" in response && "new" in response.address) {
                const body = response.address;
                dispatch(setCautiousShippingInfo(mapBackendAddress(body.new)));
                dispatch(setValidateAddressDrawerState({
                    invalid: false,
                    changed: true,
                }));
                dispatch(setOpenValidateAddressDrawer(true));
            }
            else if ("address" in response && "address" in response.address) {
                const body = mapBackendAddress(response.address);
                dispatch(setCautiousShippingInfo(body));
                dispatch(setValidateAddressDrawerState({
                    invalid: true,
                    changed: false,
                }));
                dispatch(setOpenValidateAddressDrawer(true));
            }
            return;
        }
        toastService.errorMessage("Sorry. Something went wrong");
    }
    finally {
        dispatch(setGlobalLoading(false));
    }
});
export const fetchShippingAddress = createAsyncThunk("users/fetchShippingAddress", async (_, { dispatch, getState }) => {
    const data = await apiGetUserAddress();
    if (data.address && data.firstName) {
        dispatch(setEditShippingAddress(false));
        // dispatch(setEditShippingMethod(true));
        // AB TEST
    }
    else {
        // dispatch(setEditShippingAddress(true));
    }
    return data;
});
export const fetchShippingData = createAsyncThunk("users/fetchShippingData", async (_, { dispatch }) => {
    dispatch(setLoadingShippingMethods(true));
    const data = await apiGetShippingMethod();
    dispatch(setLoadingShippingMethods(false));
    return data;
});
const checkoutShippingSlice = createSlice({
    name: "checkoutShipping",
    initialState: initState,
    reducers: {
        updateShippingInfo(state, action) {
            state.address[action.payload.name] = action.payload.value;
            return state;
        },
        setShippingInfo(state, action) {
            state.address = action.payload;
            return state;
        },
        setLoadingShippingMethods(state, action) {
            state.isLoadingShippingMethods = action.payload;
            return state;
        },
        setCautiousShippingInfo(state, action) {
            state.cautiousAddress = action.payload;
            return state;
        },
    },
    extraReducers(builder) {
        builder.addCase(fetchShippingAddress.fulfilled, (state, action) => {
            state.address.country = action.payload.country;
            state.address.street = action.payload.address;
            state.address.apartment = action.payload.address2;
            state.address.city = action.payload.city;
            state.address.zip = action.payload.zip;
            state.address.state = action.payload.state;
            state.address.firstName = action.payload.firstName;
            state.address.lastName = action.payload.lastName;
        });
        builder.addCase(fetchShippingData.fulfilled, (state, action) => {
            state.shippingMethodsData.expedited_shipping_price = action.payload.expedited_shipping_price || 0;
            state.shippingMethodsData.standard_shipping_price = action.payload.standard_shipping_price || 0;
            state.shippingMethodsData.shipping_methods = action.payload.shipping_methods;
        });
    },
});
export const { updateShippingInfo, setShippingInfo, setLoadingShippingMethods, setCautiousShippingInfo } = checkoutShippingSlice.actions;
export default checkoutShippingSlice.reducer;
